import React, { Component } from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import environment from '../../../../../../data/environment';
import IntlContainer from './components/IntlContainer';
import Divider from 'material-ui/Divider';
import CenteredErrorMessage from '../../../../../../components/CenteredErrorMessage';
import CenteredLoadingAnimation from '../../../../../../components/CenteredLoadingAnimation';

class RelayRootContainer extends Component {
  render() {
    return (
      <div className="RelayRootContainer">
        <QueryRenderer
          environment={environment}
          query={graphql`
            query RelayRootContainerQuery {
              viewer {
                ...IntlContainer_viewer
              }
            }
          `}
          render={({ error, props }) => {

            if (error) {
              console.error(error);

              return (
                <CenteredErrorMessage wait={3 * 1000}>
                  <div>
                    {`Something went wrong and data couldn't be fetched from the server. `}
                    {`Please email `}
                    <a href="mailto:support@touchandtell.se" target="_blank">support@touchandtell.se</a>
                    {` if the problem persists.`}
                  </div>
                  <br /><hr /><div>{error.message}</div>
                  <br /><div>{error.stack}</div>

                  <Divider
                    style={{
                      width: 150,
                      marginTop: '20px',
                      marginBottom: '10px',
                      display: 'inline-block',
                    }}
                  />
                  <div>
                    {`Någonting gick fel och data kunde inte hämtas från servern. `}
                    {`Vänligen maila `}
                    <a href="mailto:support@touchandtell.se" target="_blank">support@touchandtell.se</a>
                    {` om problemet inte försvinner.`}
                  </div>
                </CenteredErrorMessage>
              );
            } else if (props) {
              return <IntlContainer viewer={props.viewer} />;
            } else {
              return <CenteredLoadingAnimation />;
            }
          }}
        />
      </div>
    );
  }
}

export default RelayRootContainer;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/RelayRootContainer.js